import { Stack, Typography, useTheme } from "@mui/material";

import { RHFRadioSingle } from "@app/components";
import { Strings } from "@app/constants";

export const Section2 = ({ methods }: any) => {
  const theme = useTheme();
  const errors = methods?.formState?.errors?.carInfo?.Ownership;

  return (
    <Stack
      sx={{
        flex: 1,
        minWidth: { xs: "100%", sm: "48%" },
        flexDirection: "column",
        border: `1px solid ${
          errors ? theme.palette.error.main : theme.palette.grey[300]
        }`,
        borderRadius: 1,
        p: 2,
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}>
        {Strings.step.carInfo.ownershipRC}
      </Typography>
      <Stack flex={1} justifyContent={"space-evenly"}>
        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ xs: "start", md: "center" }}
        >
          <Typography>{Strings.step.carInfo.usageType}</Typography>
          <Stack
            flexDirection={"row"}
            flexWrap={"wrap"}
            width={{ xs: "100%", md: "auto" }}
            justifyContent={"space-between"}
          >
            <RHFRadioSingle
              name={"carInfo.Ownership.usageType"}
              value={Strings.step.carInfo.personal}
              label={Strings.step.carInfo.personal}
            />
            <RHFRadioSingle
              name={"carInfo.Ownership.usageType"}
              value={Strings.step.carInfo.commercial}
              label={Strings.step.carInfo.commercial}
            />
          </Stack>
        </Stack>
        {errors?.usageType && (
          <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
            {errors.usageType.message}
          </Typography>
        )}

        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ xs: "start", md: "center" }}
        >
          <Typography>{Strings.step.carInfo.rcAvailable}</Typography>
          <Stack
            flexDirection={"row"}
            flexWrap={"wrap"}
            width={{ xs: "100%", md: "auto" }}
            justifyContent={"space-between"}
          >
            <RHFRadioSingle
              name={"carInfo.Ownership.rcAvailable"}
              value={Strings.step.carInfo.yes}
              label={Strings.step.carInfo.yes}
            />
            <RHFRadioSingle
              name={"carInfo.Ownership.rcAvailable"}
              value={Strings.step.carInfo.no}
              label={Strings.step.carInfo.no}
            />
          </Stack>
        </Stack>
        {errors?.rcAvailable && (
          <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
            {errors.rcAvailable.message}
          </Typography>
        )}

        <Stack
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent={"space-between"}
          alignItems={{ xs: "start", md: "center" }}
        >
          <Typography>{Strings.step.carInfo.loanHyonthecation}</Typography>
          <Stack
            flexDirection={"row"}
            flexWrap={"wrap"}
            width={{ xs: "100%", md: "auto" }}
            justifyContent={"space-between"}
          >
            <RHFRadioSingle
              name={"carInfo.Ownership.isLoan"}
              value={Strings.step.carInfo.yes}
              label={Strings.step.carInfo.yes}
            />
            <RHFRadioSingle
              name={"carInfo.Ownership.isLoan"}
              value={Strings.step.carInfo.no}
              label={Strings.step.carInfo.no}
            />
          </Stack>
        </Stack>
        {errors?.isLoan && (
          <Typography color="error" variant="caption" sx={{ mt: 0.5, fontWeight: 500 }}>
            {errors.isLoan.message}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
